function parse(v) {
  const [core, pre] = String(v).split('-');
  const nums = core.split('.').map((n) => parseInt(n, 10) || 0);
  return { nums, hasPre: pre !== undefined };
}

export default function compareVersions(a, b) {
  const pa = parse(a);
  const pb = parse(b);
  const len = Math.max(pa.nums.length, pb.nums.length);
  for (let i = 0; i < len; i++) {
    const da = pa.nums[i] || 0;
    const db = pb.nums[i] || 0;
    if (da !== db) return da < db ? -1 : 1;
  }
  if (pa.hasPre !== pb.hasPre) return pa.hasPre ? -1 : 1; // pre-release < base
  return 0;
}
